import { Component, inject, input, linkedSignal, signal, viewChild } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Notification, Button, NotificationService } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-location-details-edit-success-notification',
  imports: [Notification, Button, NgIcon, TranslocoPipe],
  templateUrl: './location-details-edit-success-notification.html',
})
export class LocationDetailsEditSuccessNotification {
  private notificationService = inject(NotificationService);
  private translocoService = inject(TranslocoService);

  notification = viewChild(Notification);
  uuid = input.required<string>();
  duration = input.required<number>();

  clickUndoCallback = input.required<() => Promise<void>>();

  customDuration = linkedSignal(this.duration);

  loading = signal(false);

  async onClickUndo() {
    this.loading.set(true);
    this.notificationService.stopDismissTimeout(this.uuid());
    this.customDuration.set(0);
    try {
      const undoCallback = this.clickUndoCallback();
      await undoCallback();
      const successMsg = this.translocoService.translate(
        'cockpit.locations.details.notifications.editSuccess.undoSuccess',
      );
      this.notificationService.showSuccess({
        title: successMsg,
      });
    } catch (e) {
      console.error('Undo failed', e);
      const errorMsg = this.translocoService.translate(
        'cockpit.locations.details.notifications.editSuccess.undoError',
      );
      this.notificationService.showError({
        title: errorMsg,
      });
    } finally {
      this.notificationService.dismiss(this.uuid());
    }
  }
}
